import { render, staticRenderFns } from "./LandSecond.vue?vue&type=template&id=11f59e90&scoped=true&"
import script from "./LandSecond.vue?vue&type=script&lang=js&"
export * from "./LandSecond.vue?vue&type=script&lang=js&"
import style0 from "./LandSecond.vue?vue&type=style&index=0&id=11f59e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f59e90",
  null
  
)

export default component.exports